import ApiService from './api'


export const StickerService = {
    getStickerBalance(userId) {
        return ApiService.get('/sticker/list?user_id=' + userId)
    },

    getStreamPreview(userId) {
        return ApiService.get('/stream?user_id=' + userId)
    },

    getStickers(userId) {
        return ApiService.get('/sticker?user_id=' + userId)
    },

    postStickers(data) {
        return ApiService.post('/sticker', data)
    },

    putSticker({id, is_active}) {
        return ApiService.put(`/sticker/${ id }`, {
            is_active,
        })
    },

    delStickers(id) {
        return ApiService.delete('/sticker/' + id)
    },

    putStickers({stickers_ids, is_active}) {
        return ApiService.put('/sticker', {
            stickers_ids,
            is_active,
        })
    },
}